import i18n from 'i18next';
import React from 'react';
import {OrganizationSelection, SwList} from 'simplifyworks-core-ui';
import {FaPlus} from 'react-icons/fa';
import {equalsOnlyHeadFilterOperators, FOEDUS_ROLE} from '../../domain/constants';
import {connect} from 'react-redux';
import {CountryWithFlag} from '../renderers/renderers';

const OrganizationsList = (props) => {
	return <>

		<SwList
			name='foedus-contacts-organizations-list'
			restPrefix='/api/foedus/contacts/organizations'
			defaultOrdering={[{property: 'created', order: 'desc'}]}
		>

			{props?.canManageOrganizations && (
				<SwList.ActivitiesGroup>
					<SwList.Link
						icon={FaPlus}
						labelKey='foedus-organization-create-new'
						path={'/contacts/organizations/new'}
					/>
				</SwList.ActivitiesGroup>
			)}

			<SwList.Table minWidth='480px'>

				<SwList.Custom
					property='logo'
					width='60px'
					label=' '
					orderable={false}
					render={record => {
						const base64Image = record?.organization?.fieldValuesMap?.logo;
						if (base64Image) {
							return <img
								src={`data:image/png;base64,${base64Image}`}
								alt="Logo"
								style={{
									maxWidth: '50px',
									maxHeight: '50px'
								}}
							/>;
						} else {
							return null;
						}
					}}
				/>
				<SwList.String
					property='organization.name'
					labelKey='core-organization-name'
					width='40%'
					path='/contacts/organizations'
					pathProperty='id'
					filterable
					hiddenHeadFilterOperators={equalsOnlyHeadFilterOperators}
				/>
				<SwList.String
					property='organization.abbreviation'
					labelKey='core-organization-abbreviation'
					filterable
					hiddenHeadFilterOperators={equalsOnlyHeadFilterOperators}
				/>
				<SwList.Entity
					filterable
					hiddenHeadFilterOperators={equalsOnlyHeadFilterOperators}
					property='organization.organization'
					labelKey='foedus-country'
					renderHeadFilter={org => OrganizationSelection.renderText(org) || ''}
					render={(resource) => <CountryWithFlag
						code={resource?.code}
						name={resource?.name ?? resource?.nameEng}
					/>}
				>
					{OrganizationSelection.renderSelection({
						name: 'foedus-country',
						fixedFilter: {
							organizationTypes: [props?.countryCoreCodebook]
						}
					})}
				</SwList.Entity>

				<SwList.String
					property='organization.code'
					labelKey='core-organization-code'
					width='15%'
					filterable
					hiddenHeadFilterOperators={equalsOnlyHeadFilterOperators}
				/>

				<SwList.Number
					property='usersWithNotificationsEnabledCount'
					labelKey='foedus-contacts-usersWithNotificationEnabled'
					pathFunc={resource => {
						return '/contacts/people?organization=' + resource?.organization?.id + '&name=' + resource?.organization?.name + '&usersWithNotificationsEnabled=true';
					}}
				/>
				<SwList.Number
					property='activeUsersCount'
					labelKey='foedus-organization-activeUsersCount'
					pathFunc={resource => {
						return '/contacts/people?organization=' +  resource?.organization?.id + '&name=' + resource?.organization?.name + '&activeUser=true';
					}}
				/>
			</SwList.Table>

			<SwList.Info />
			<SwList.Pagination />

		</SwList>
	</>;
};

const mapStateToProps = (state) => {
	return {
		canManageOrganizations:
			state?.security?.allRoles?.includes('admin')
			|| state?.security?.allRoles?.includes(FOEDUS_ROLE.ADMIN),
		countryCoreCodebook: state?.foedus?.countryCoreCodebook
	};
};
export default {
	title: () => i18n.t('foedus-contacts-organizations-title-list'),
	main: connect(mapStateToProps)(OrganizationsList)
};
